// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"76":"d83256d9","113":"bbfba131","142":"ad43b07c","438":"28c3cbeb","538":"6eda5304","972":"2f2d35b5"}[chunkId] + ".chunk.js";
};